"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DiscountInfoCard = void 0;
var React = require("react");
var CountDown_1 = require("../CountDown");
var styles_1 = require("./styles");
exports.DiscountInfoCard = function (props) {
    var ltImg = props.ltImg, rtImg = props.rtImg, countdownToEnd = props.countdownToEnd;
    if (!ltImg && !rtImg && !countdownToEnd) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(styles_1.LTImg, { src: ltImg }),
        React.createElement(styles_1.RTImg, { src: rtImg }),
        React.createElement(styles_1.Bottom, null,
            React.createElement(CountDown_1.default, { countTime: countdownToEnd }))));
};
